/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientName
 */
export interface ClientName {
    /**
     * 
     * @type {string}
     * @memberof ClientName
     */
    name: string;
}

export function ClientNameFromJSON(json: any): ClientName {
    return ClientNameFromJSONTyped(json, false);
}

export function ClientNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function ClientNameToJSON(value?: ClientName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


